module.exports = __webpack_public_path__ + "img/renaissance_cleaning_services_1.e8f23050.jpg";